import React from 'react';
import {Drawer} from "antd";
import CustomModal from "../../components/UI/CustomModal";
import useScreenSize from "../../helpers/hooks/useScreenSize";
import {t} from "i18next";
import {Btn, FlexColumnSection, FlexRowSection, SmallText} from "../../styles/globalStyles";
import {Colors} from "@arboxappv4/shared/src/styles/Colors";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {light} from "@fortawesome/fontawesome-svg-core/import.macro";

const ConfirmationModal = (props) => {
    const { isOpen, onClose, onConfirm, header, explanation, hideClose, hideSubmit, submitText, content, ...rest} = props;
    const {isMobile} = useScreenSize();

    const onProceedClick = () => {
        onConfirm()
        onClose(true)
    }

    const getHeader = () => {
        return (
            <FlexRowSection justify={'space-between'}>
                {header}
                <div onClick={onClose}><FontAwesomeIcon icon={light('x')} color={Colors.siteBlack} size={'xs'}/></div>
            </FlexRowSection>
        )
    }

    return (
        <>
            {
                isMobile ?
                    <Drawer
                        placement={'bottom'}
                        closable={false}
                        onClose={onClose}
                        open={isOpen}
                        style={{borderTopLeftRadius: 20, borderTopRightRadius: 20}}
                        styles={{body: {padding: '16px'}}}
                        onOk={onConfirm}
                        title={getHeader()}
                        headerStyle={{borderWidth: 0, padding: '16px 16px 0'}}
                        {...rest}
                    >
                        <FlexColumnSection gap={'16px'}>
                            {explanation && <SmallText>{explanation}</SmallText>}
                            {content}
                            <FlexRowSection gap={'10px'} justify={'end'}>
                                {!hideClose && <Btn onClick={onClose} flex={1}>{t('close')}</Btn>}
                                {!hideSubmit && <Btn type={'primary'} onClick={onProceedClick} flex={1}>{submitText ?? t('proceed')}</Btn>}
                            </FlexRowSection>
                        </FlexColumnSection>
                    </Drawer>
                    :
                    <CustomModal open={isOpen} onCancel={onClose} title={header} width={'500px'} {...rest}>
                        <FlexColumnSection gap={content ? '16px' : '10px'}>
                            {explanation && <SmallText>{explanation}</SmallText>}
                            {content}
                            <FlexRowSection gap={'10px'} justify={'end'}>
                                {!hideClose && <Btn onClick={onClose}>{t('close')}</Btn>}
                                {!hideSubmit && <Btn type={'primary'} onClick={onProceedClick}>{submitText ?? t('proceed')}</Btn>}
                            </FlexRowSection>
                        </FlexColumnSection>
                    </CustomModal>
            }
        </>

    );
};

export default ConfirmationModal;